export default "__VITE_ASSET__FOQxgtro__"